<script>
  export default{
    name : 'OpposeLobbyIcon'
  }
</script>
<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM5.96522 5.96518C6.55583 5.37458 7.5134 5.37458 8.104 5.96518L10 7.86118L11.896 5.96518C12.4866 5.37458 13.4442 5.37458 14.0348 5.96518C14.6254 6.55579 14.6254 7.51336 14.0348 8.10396L12.1388 9.99996L13.9856 11.8468C14.5763 12.4374 14.5763 13.395 13.9856 13.9856C13.395 14.5762 12.4375 14.5762 11.8469 13.9856L10 12.1387L8.15313 13.9856C7.56252 14.5762 6.60495 14.5762 6.01435 13.9856C5.42374 13.395 5.42374 12.4374 6.01435 11.8468L7.86122 9.99996L5.96522 8.10396C5.37462 7.51336 5.37462 6.55579 5.96522 5.96518Z" fill="#9D2809"/>
  </g>
</template>